import { useTheme as useMuiTheme } from '@mui/material'

const useTheme = () => {
    const theme = useMuiTheme()

    return theme
}

export default useTheme
